module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-profile"
  }, [_c('div', {
    staticClass: "card-avatar"
  }, [_c('a', {
    attrs: {
      "href": "#pablo"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "static/img/faces/marc.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h6', {
    staticClass: "category text-gray"
  }, [_vm._v("CEO / Co-Founder")]), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Alec Thompson")]), _vm._v(" "), _c('p', {
    staticClass: "card-content"
  }, [_vm._v("\n    Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-round",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Follow")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0fd2bac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/UserProfile/UserCard.vue
// module id = 174
// module chunks = 2